import { TypedUseSelectorHook,  useDispatch, useSelector } from 'react-redux'
import { RootState } from "store/reducers/index"
import { AppDispatch } from '../../../config/store';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch